export enum ParameterType {
    text = 'text',
    number = 'number',
    list = 'list',
    multiple = 'multiple'
}
